import {
    faAddressCard, faChartLine, faBuilding, faRoute, faStar, faBullhorn, faHeartbeat,
} from '@fortawesome/free-solid-svg-icons';

export const CRM_NAV = [
    { to: '/crm', label: 'Contact 360', icon: faAddressCard, end: true },
    { to: '/crm/lifecycle', label: 'Patient Lifecycle', icon: faChartLine },
    { to: '/crm/accounts', label: 'Account Management', icon: faBuilding },
    { to: '/crm/onboarding', label: 'Onboarding Pipelines', icon: faRoute },
    { to: '/crm/feedback', label: 'Feedback & NPS', icon: faStar },
    { to: '/crm/campaigns', label: 'Campaigns & Outreach', icon: faBullhorn },
    { to: '/crm/health', label: 'Churn & Health Scores', icon: faHeartbeat },
];

export const TYPE_COLORS: Record<string, string> = {
    patient: 'info', provider: 'success', institution: 'primary', staff: 'secondary',
};

export const STAGE_COLORS: Record<string, string> = {
    invited: 'secondary', registered: 'info', profile_complete: 'info',
    credentials_uploaded: 'primary', first_patient: 'primary', first_record: 'primary',
    active: 'success', stalled: 'warning', withdrawn: 'danger',
};

export const BAND_COLORS: Record<string, string> = {
    healthy: 'success', watch: 'warning', at_risk: 'danger',
    promoter: 'success', passive: 'warning', detractor: 'danger',
};
